/**
 * This is a "controller" TextField component, made to work with
 * react-hooks-form.
 */
import React from 'react';
import {
  Controller,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';
import TextField, { type TextFieldProps } from '@mui/material/TextField';

type ControlledTextFieldProps<T extends FieldValues> = TextFieldProps &
  UseControllerProps<T>;

export default function ControlledTextField<T extends FieldValues>({
  name,
  defaultValue,
  control,
  shouldUnregister = false,
  rules = {},
  ...props
}: ControlledTextFieldProps<T>) {
  return (
    <Controller
      {...(typeof defaultValue !== 'undefined' && { defaultValue })}
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...rest } }) => (
        <TextField inputRef={ref} {...props} {...rest} />
      )}
      shouldUnregister={shouldUnregister}
    />
  );
}
